import { DocumentResponse, DocumentsResponse } from 'all-in-one-shared-api/dist/apis/documents/DocumentsResponse';
import { PolicyInfoResponse } from 'all-in-one-shared-api';

import { getLatestPolicyYearRange } from './getLatestPolicyYearRange';
import { getBenefitScheduleDetailsByName } from 'utils';

import i18n from 'i18n';

export const getAvailableDocuments = (
  documentsData: DocumentsResponse | undefined,
  policyInfoData: PolicyInfoResponse[] | undefined,
  memberType: string,
  renewalNumbers: number[],
  isEnglish: boolean,
): DocumentResponse[] => {
  if (documentsData && policyInfoData) {
    const items: DocumentResponse[] = [];

    const hasBenefitSchedules = documentsData.benefitSchedule && documentsData.benefitSchedule.length > 0;
    if (hasBenefitSchedules) {
      documentsData.benefitSchedule?.map((benefitSchedule) => {
        const { renewalNumber } = getBenefitScheduleDetailsByName(benefitSchedule.name);
        if (renewalNumber) {
          const benefitScheduleDetailsRenewalNumber = parseInt(renewalNumber);
          if (renewalNumbers.includes(benefitScheduleDetailsRenewalNumber)) {
            const latestPolicyYearRange = getLatestPolicyYearRange(
              policyInfoData,
              memberType,
              benefitScheduleDetailsRenewalNumber,
            );
            items.push({
              ...benefitSchedule,
              name: i18n.t('documents.benefitSchedule'),
              documentDate: latestPolicyYearRange,
            });
          }
        }
      });
    }

    const hasPolicyGuide = documentsData.policyGuides && documentsData.policyGuides.docUrlEn;
    if (hasPolicyGuide) {
      const { docUrlEn, docUrlTc } = documentsData.policyGuides || {};

      const policyGuide: DocumentResponse = {
        name: i18n.t('documents.memberGuide'),
        url: isEnglish ? docUrlEn : docUrlTc,
        category: 'policyGuide',
        documentDate: getLatestPolicyYearRange(policyInfoData, memberType, renewalNumbers[0]),
      };
      items.push(policyGuide);
    }

    return items;
  }
  return [];
};
